import RecordableView from '@/template/views/RecordableView.vue';
import BasicInfoView from '@/template/components/expandedSBE/ExpandedBasicInfoView.vue';
import OperationView from '@/template/components/expandedSBE/ExpandedOperationView.vue';
import BudgetaryEstimateView from '@/template/components/expandedSBE/ExpandedBudgetaryEstimateView.vue';
import { AidType } from '@/common/types/AidType';
var titleKey = function () { return 'Expanded.Title'; };
var specifierKey = function (expanded) {
    var key = null;
    if (expanded && expanded.aidType !== undefined) {
        var type = AidType[expanded.aidType];
        key = "AidApplication.AidType." + type + (expanded.isPlaceOpen ? "_PlaceOpen" : "");
    }
    return key;
};
var instructionLinksFactory = function (configuredLinks, languageCode, expanded) {
    var type = null;
    if (expanded) {
        type = expanded.isPlaceOpen ? "placeOpen" : AidType[expanded.aidType];
    }
    return {
        id: "expandedsbe",
        type: type
    };
};
var basicInfo = function (expanded) {
    return {
        basicInfo: expanded.basicInfo,
        specification: expanded.specification
    };
};
var operation = function (expanded) {
    return {
        operation: expanded.operation,
        specification: expanded.specification
    };
};
var budgetary = function (expanded) {
    return {
        budgetaryEstimate: expanded.budgetaryEstimate,
        specification: expanded.specification,
    };
};
export var route = {
    path: '/expandedsbe/:id',
    component: RecordableView,
    props: {
        titleKey: titleKey,
        specifierKey: specifierKey,
        recordableType: "ExpandedStrategyAndBudgetaryEstimate",
        instructionLinksFactory: instructionLinksFactory,
        multipleSections: true
    },
    children: [
        {
            name: 'expandedsbe',
            path: '',
            component: BasicInfoView,
            meta: {
                title: 'Expanded.Menu.BasicInfo',
                section: 1,
                props: basicInfo,
                deletable: false
            }
        },
        {
            name: 'expandedsbe-operation',
            path: 'operation',
            component: OperationView,
            meta: {
                title: 'Expanded.Menu.Operation',
                section: 2,
                props: operation,
                deletable: false
            }
        },
        {
            name: 'expandedsbe-budgetary-estimate',
            path: 'budgetaryEstimate',
            component: BudgetaryEstimateView,
            meta: {
                title: 'Expanded.Menu.BudgetaryEstimate',
                section: 3,
                props: budgetary,
                deletable: false
            }
        }
    ]
};
